/*
* @Author: msmiller
* @Date:   2020-06-16 17:52:13
* @Last Modified by:   msmiller
* @Last Modified time: 2021-07-22 14:02:02
*
* Copyright (c) Sharp Stone Codewerks / Mark S. Miller
*/

$(document).on('turbolinks:load', function() {
  $('.flash-notification')
    .delay(3000)
    .queue(function() {
        $(this).fadeOut('slow').dequeue();
    });
});

$(document).on('turbo:load', function() {
  $('.flash-notification')
    .delay(3000)
    .queue(function() {
        $(this).fadeOut('slow').dequeue();
    });
});

$(document).on('turbo:load', function() {
  $("#wgmain").scroll(function() {
    //console.log("SCROLL");
    var scrollTop = $(this).scrollTop();
    //console.log(scrollTop);
    if (scrollTop == 0) {
      //console.log("HIDE");
      $("#top-arrow").removeClass('text-red-500 fas fas-arrow-circle-up');
      $("#top-arrow").addClass('text-gray-300 far fa-arrow-alt-circle-up');
    } else {
      $("#top-arrow").removeClass('text-gray-300 far fa-arrow-alt-circle-up');
      $("#top-arrow").addClass('text-red-500 fas fas-arrow-circle-up');
    }
  });
});
